/**
 * @author AUTHOR_NAME
 * @email AUTHOR_EMAIL
 * @create date
 * @modify date
 * @desc withAllContexts HOC will send all the necessary Context such as AlertContext,
 * DialogContext, BackdropContext and DrawerContext as a prop.
 */

import React from "react";
import {
  AlertContext,
  DialogContext,
  BackdropContext,
  DrawerContext,
  AuthContext,
  RoleNameContext
} from "../contexts";

const withAllContexts = (Component) => (props) => {
  const auth = React.useContext(AuthContext);
  const alert = React.useContext(AlertContext);
  const dialog = React.useContext(DialogContext);
  const backDrop = React.useContext(BackdropContext);
  const drawer = React.useContext(DrawerContext);
  const Rolename = React.useContext(RoleNameContext);

  return (
    <Component
      {...props}
      alert={alert}
      auth={auth}
      dialog={dialog}
      backDrop={backDrop}
      drawer={drawer}
      Rolename={Rolename}
      
    >
      {props.children}
    </Component>
  );
};

export default withAllContexts;
